<div class="fp-wrap">
  <div class="fp-field-bg" aria-hidden="true"></div>

  <div class="fp-stage">
    <lib-bo-auth-card
      [title]="'Recuperar contrasena'"
      [subtitle]="'Te enviaremos un enlace para restablecer tu contrasena.'"
    >
      <lib-bo-auth-brand [appName]="'My Sport App'" [tagline]="'Recuperacion de cuenta'">
        <svg brand-icon viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 118 0v3"/></svg>
      </lib-bo-auth-brand>

      @if (!emailSent()) {
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="fp-form">
          <lib-bo-auth-input
            [inputId]="'fp-email'"
            [label]="'Correo electronico'"
            [placeholder]="'Ingresa tu correo electronico'"
            [inputType]="'email'"
            [autocomplete]="'email'"
            [control]="form.controls.email"
            [hasIcon]="true"
          >
            <svg icon viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>
          </lib-bo-auth-input>

          <lib-bo-auth-submit-button
            [label]="'Enviar enlace de recuperacion'"
            [variant]="'primary'"
            [loading]="isLoading()"
            [disabled]="form.controls.email.invalid"
          >
            <svg btn-icon viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg>
          </lib-bo-auth-submit-button>
        </form>
      } @else {
        <div class="fp-success">
          <div class="fp-icon-badge" aria-hidden="true">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
            </svg>
          </div>
          <h2 class="fp-success-heading">Correo enviado</h2>
          <p class="fp-success-text">
            Hemos enviado un enlace de recuperacion a tu correo electronico.
            Revisa tu bandeja de entrada y sigue las instrucciones.
          </p>
          <button type="button" class="fp-resend" (click)="resend()">Enviar de nuevo</button>
        </div>
      }

      <div class="fp-back">
        <a [routerLink]="loginRoute" class="fp-back-link">
          <svg class="fp-back-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/></svg>
          Volver al inicio de sesion
        </a>
      </div>
    </lib-bo-auth-card>
  </div>
</div>
